module.exports = __webpack_public_path__ + "img/high-risk.6c8e7e9e.png";